import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visibleColumns: {
    donorId: true,
    registrationDate: true,
    donorName: true,
    createdBy: false,
    nextAppointment: false,
    aadharNumber: false,
    age: false,
    hairColor: false,
    eyeColor: false,
    skinColor: false,
    height: false,
    weight: false,
    gender: false,
    dateOfBirth: false,
    placeOfBirth: false,
    donationType: false,
    email: false,
    lmpDate: false,
    lmpDay: false,
    bloodGroup: true,
    religion: true,
    address: false,
    referredDoctors: false,
    allottedHospitalDoctor: false,
    labTechnician: false,
    reportSubmittedAt: false,
    consentForm: false,
    affidavit: false,
    bloodReport: false,
    follicularScan: false,
    insurance: false,
    opuProcess: false,
  },
};

const columnSlice = createSlice({
  name: 'column',
  initialState,
  reducers: {
    toggleColumn: (state, action) => {
      const column = action.payload;
      state.visibleColumns[column] = !state.visibleColumns[column];
    },
    setVisibleColumns: (state, action) => {
      state.visibleColumns = { ...state.visibleColumns, ...action.payload };
    },
    resetColumns: (state) => {
      state.visibleColumns = initialState.visibleColumns;
    },
  },
});

export const { toggleColumn, setVisibleColumns, resetColumns } = columnSlice.actions;
export default columnSlice.reducer;
